<button pButton class="p-button-rounded p-button-outlined p-button-secondary" (click)="showModalDialog()" icon="pi pi-question-circle" label="{{buttonLabel}}"></button>
<p-dialog [dismissableMask]="true" header="{{title}}" [(visible)]="displayModal" [modal]="true" [style]="{width: '50vw'}"
          [draggable]="false" [resizable]="false">
    <ng-content></ng-content>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="displayModal=false" label="Ok" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>
